import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

export default {

  init() {
    window.openNav = function() {
      var element = document.getElementById('mobileNav');
      element.classList.add('show');
    };

    window.closeNav = function() {
      var element = document.getElementById('mobileNav');
      element.classList.remove('show');
    };

    if ($(window).width() > 960) {
      window.onscroll = function() {
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
          document.getElementById("resizeLogo").style.maxWidth = "120px";
          document.getElementById("headerSearch").style.visibility = "hidden";
        } else {
          document.getElementById("resizeLogo").style.maxWidth = "220px";
          document.getElementById("headerSearch").style.visibility = "visible";
        }
      }
    } else {
      window.onscroll = function() {
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
          document.getElementById("resizeLogo").style.maxWidth = "120px";
        } else {
          document.getElementById("resizeLogo").style.maxWidth = "160px";
        }
      }
    }
  },
  finalize() {
    document.querySelectorAll('.dropdown-menu').forEach(function(element) {
      element.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });

    $( ".dropdown-menu" ).css('margin-top',0);
    $( ".dropdown" )
      .mouseover(function() {
        $( this ).addClass('show').attr('aria-expanded',"true");
        $( this ).find('.dropdown-menu').addClass('show');
      })
      .mouseout(function() {
        $( this ).removeClass('show').attr('aria-expanded',"false");
        $( this ).find('.dropdown-menu').removeClass('show');
      });

    // Init Swiper slider for Top Destination
    
    var swiperTop = new Swiper('.topDestination', {
      slidesPerView: 4,
      spaceBetween: 25,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        370: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1.6,
          spaceBetween: 10,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 35,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    // Init Swiper slider for Travel designer
    var swiperDesigner = new Swiper('.travelDesigner', {
      slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    // Init Swiper slider for Article img gallery

    var swiperArt = new Swiper('.articleGallery', {
      slidesPerView: 1,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var swiperDest = new Swiper('.destinations', {
      slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        // when window width is >= 576px
        576: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 992px
        992: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
};
